// İSG uzmanı portalı — Kullanıcılar (Users) TanStack Query anahtarları (api-contract
// §12, tenant-scoped). İki kullanım: (a) Ziyaretçi check-in ev sahibi (host) seçicisini
// besleyen aktif kullanıcı listesi; (b) Expert paneli kullanıcı yönetimi ekranı (liste +
// detay + rol seçici + erişim sondası). Liste anahtarı parametreleri içerir (arama/sayfa
// değişince yeniden çeker); invalidasyon önek (prefix) ile yapılır: `['users','list']` tüm
// kullanıcı listesi sorgularını kapsar (host + yönetim varyantları dahil).
//
// Ayarlar (§10) / Admin (§9) anahtarlarından AYRIDIR — Kullanıcılar tek firmaya kapsanmış
// tenant yüzeyidir (merkezî identity store; §12).

import type { UserListParams } from '@isgportal/shared';

export const usersKeys = {
  /** Tüm kullanıcı listesi sorgularının öneki — invalidasyon için. */
  list: () => ['users', 'list'] as const,
  /** Check-in ev sahibi seçicisi için kullanıcılar (tek sayfa, ada göre sıralı). */
  hostOptions: (params: UserListParams) => ['users', 'list', 'host-options', params] as const,
  /** Yönetim ekranı sayfalı + aranabilir liste — parametreli (arama/sayfa varyantları). */
  listParams: (params: UserListParams) => ['users', 'list', 'manage', params] as const,
  /** Tek kullanıcı detayı (tam rol seti) — düzenle formu ön-seçimi. */
  detail: (uuid: string) => ['users', 'detail', uuid] as const,
  /** Atanabilir rol seçici (`GET /roles`, §12.2) — form kaynağı. */
  roles: () => ['users', 'roles'] as const,
  /** Erişim sondası (gate) — hafif liste probu (page=1, pageSize=1). */
  access: () => ['users', 'access'] as const,
} as const;
